import Actions from './action';
export const initState = {
	details: null,
	registerLoading: false,
	registerSuccess: false,
};

const registerReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.REGISTER_STARTED: {
			return {
				...state,
				registerLoading: !state.registerLoading,
			};
		}
		case Actions.types.REGISTER_SUCCESS: {
			return {
				...state,
				registerLoading: !state.registerLoading,
				registerSuccess: true,
				details: action.details,
			};
		}
		case Actions.types.REGISTER_COMPLETED: {
			return {
				...state,
				registerLoading: !state.registerLoading,
			};
		}

		default:
			return state;
	}
};

export default registerReducer;
